import { Card, CardBody, Col, Label, Row } from 'reactstrap';
import InputSelect from 'components/InputSelect';
import { PropostaMeioPagamento } from 'models/PropostaMeioPagamento';
import BancoFinanciamento from 'models/BancoFinanciamento';
import Subtitle from 'views/components/Subtitle';
import Swal from 'sweetalert2';
import { useEffect } from 'react';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core';
import {
  iAcessoPrograma,
  iComboList,
  iListaTaxaFlat,
  iPropostaDados,
} from '../..';
import gerarParcelasDefault from './components/GerarParcelasDefault';

export default function MeioPagamento({
  propostaVersao,
  meioPagamentos,
  bancosFinanciamento,
  propostaLinhaCredito,
  formatoBanco,
  isModoSimulacao,
  onChange,
  listaFlat,
  acessoPrograma,
}: {
  propostaVersao: iPropostaDados;
  meioPagamentos: PropostaMeioPagamento[];
  bancosFinanciamento: BancoFinanciamento[];
  propostaLinhaCredito: iComboList[];
  formatoBanco: iComboList[];
  listaFlat: iListaTaxaFlat[];
  isModoSimulacao: boolean;
  acessoPrograma: iAcessoPrograma;
  onChange: (a: iPropostaDados) => void;
}): JSX.Element {
  function trocarMeioPagamento(pVersao: iPropostaDados, value: string) {
    Swal.fire({
      title: `Houve alteração no meio de pagamento, as parcelas precisarão ser redefinidas, deseja continuar?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `Sim`,
      confirmButtonColor: '#d33',
      cancelButtonText: `Não`,
    }).then(result => {
      if (result.isConfirmed) {
        const isFinanciado =
          meioPagamentos.find(
            meioPagamento => meioPagamento.id === Number(value),
          )?.financiado ?? false;

        const meioId = Number(value);

        const novasParcelas = gerarParcelasDefault(propostaVersao, meioId);

        onChange({
          ...pVersao,
          valores: {
            ...pVersao.valores,
            percentualTaxaFlat: isFinanciado
              ? pVersao.valores.percentualTaxaFlat
              : 0,
          },
          meioPagamento: {
            ...pVersao.meioPagamento,
            meioPagamento: Number(value),
            bancoProposta: isFinanciado
              ? pVersao.meioPagamento.bancoProposta
              : '',
            formatoBanco: isFinanciado
              ? pVersao.meioPagamento.formatoBanco
              : '',
            linhaCredito: isFinanciado ? pVersao.meioPagamento.linhaCredito : 0,
          },
          parcelas: novasParcelas, // para trazer as parcelas default do meio de pagamento selecionado
        });
      }
    });
  }

  if (!propostaVersao) return <></>;

  const isFinanciado =
    meioPagamentos.find(
      meioPagamento =>
        meioPagamento.id === propostaVersao.meioPagamento.meioPagamento,
    )?.financiado ?? false;

  return (
    <Card className="shadow p-3">
      <Subtitle name="Forma de Pagamento" />
      <CardBody>
        <Row>
          <Col className="mb-2" xs="6" lg="3">
            <FormControl
              fullWidth
              disabled={propostaVersao.outros?.isParcelamentoEspecial}
              style={{ minWidth: 20 }}
              error={propostaVersao.meioPagamento.meioPagamento === 0}
            >
              <InputLabel variant="standard" htmlFor="meio-pagamento">
                Meio de pagamento
              </InputLabel>
              <Select
                labelId="meio-pagamento"
                id="select"
                disabled={
                  !isModoSimulacao ||
                  propostaVersao.outros?.isParcelamentoEspecial
                }
                value={propostaVersao.meioPagamento.meioPagamento}
                label="Meio de pagamento"
                variant="standard"
                inputProps={{
                  name: 'meio-pagamento',
                  id: 'meio-pagamento',
                }}
                MenuProps={{
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                  },
                  transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                  },
                  getContentAnchorEl: null,
                }}
                onChange={text =>
                  trocarMeioPagamento(
                    propostaVersao,
                    text.target.value as string,
                  )
                }
              >
                {meioPagamentos.map(meioPagamento => {
                  return (
                    <MenuItem value={meioPagamento.id}>
                      {meioPagamento.descricao}
                    </MenuItem>
                  );
                })}
              </Select>
              <FormHelperText
                hidden={propostaVersao.meioPagamento.meioPagamento !== 0}
              >
                {propostaVersao.meioPagamento.meioPagamento === 0
                  ? 'Obrigatório.'
                  : ''}
              </FormHelperText>
            </FormControl>
          </Col>
          {isFinanciado && (
            <>
              <Col className="mb-2" xs="6" lg="3">
                <FormControl
                  fullWidth
                  style={{ minWidth: 20 }}
                  error={propostaVersao.meioPagamento.bancoProposta === ''}
                >
                  <InputLabel variant="standard" htmlFor="banco">
                    Banco
                  </InputLabel>
                  <Select
                    labelId="select-label"
                    id="select"
                    disabled={!isModoSimulacao}
                    value={propostaVersao.meioPagamento.bancoProposta ?? null}
                    label="Banco"
                    variant="standard"
                    inputProps={{
                      name: 'banco',
                      id: 'banco',
                    }}
                    onChange={text => {
                      const banco = text.target.value as string;

                      const taxaFlat =
                        listaFlat.find(
                          item =>
                            (item.codigoBanco === banco &&
                              item.formato ===
                                propostaVersao.meioPagamento.formatoBanco) ??
                            '',
                        )?.percTaxa ?? 0;

                      onChange({
                        ...propostaVersao,
                        valores: {
                          ...propostaVersao.valores,
                          percentualTaxaFlat: taxaFlat,
                        },
                        meioPagamento: {
                          ...propostaVersao.meioPagamento,
                          bancoProposta: banco ?? null,
                        },
                      });
                    }}
                  >
                    {bancosFinanciamento.map(bancoFinanciamento => {
                      return (
                        <MenuItem value={bancoFinanciamento.codigo}>
                          {bancoFinanciamento.razaoSocial}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  <FormHelperText
                    hidden={propostaVersao.meioPagamento.bancoProposta !== ''}
                  >
                    {propostaVersao.meioPagamento.bancoProposta === '' ||
                    propostaVersao.meioPagamento.bancoProposta === null
                      ? 'Obrigatório.'
                      : ''}
                  </FormHelperText>
                </FormControl>
              </Col>
              <Col className="mb-2" xs="6" lg="3">
                <FormControl
                  fullWidth
                  error={propostaVersao.meioPagamento.formatoBanco === ''}
                >
                  <InputLabel variant="standard" htmlFor="formato">
                    Formato
                  </InputLabel>
                  <Select
                    labelId="select-label"
                    id="select"
                    disabled={!isModoSimulacao}
                    value={propostaVersao.meioPagamento.formatoBanco ?? ''}
                    label="Formato"
                    variant="standard"
                    inputProps={{
                      name: 'formato',
                      id: 'formato',
                    }}
                    MenuProps={{
                      anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                      },
                      transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left',
                      },
                      getContentAnchorEl: null,
                    }}
                    onChange={text => {
                      const valor = text.target.value as string;

                      const taxaFlat =
                        listaFlat.find(
                          item =>
                            (item.formato === valor &&
                              item.codigoBanco ===
                                propostaVersao.meioPagamento.bancoProposta) ??
                            '',
                        )?.percTaxa ?? 0;

                      onChange({
                        ...propostaVersao,
                        valores: {
                          ...propostaVersao.valores,
                          percentualTaxaFlat: taxaFlat,
                        },
                        meioPagamento: {
                          ...propostaVersao.meioPagamento,
                          formatoBanco: valor,
                        },
                      });
                    }}
                  >
                    {formatoBanco.map(formatoBanc => {
                      return (
                        <MenuItem value={formatoBanc.value}>
                          {formatoBanc.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  <FormHelperText
                    hidden={propostaVersao.meioPagamento.formatoBanco !== ''}
                  >
                    {propostaVersao.meioPagamento.formatoBanco === ''
                      ? 'Obrigatório.'
                      : ''}
                  </FormHelperText>
                </FormControl>
              </Col>
              <Col className="mb-2" xs="6" lg="3">
                <FormControl
                  fullWidth
                  error={propostaVersao.meioPagamento.linhaCredito === 0}
                >
                  <InputLabel variant="standard" htmlFor="linha-credito-select">
                    Linha de Crédito
                  </InputLabel>
                  <Select
                    labelId="select-label"
                    id="linha-credito-select"
                    disabled={!isModoSimulacao}
                    value={propostaVersao.meioPagamento.linhaCredito ?? 0}
                    // label="Linha-credito"
                    variant="standard"
                    inputProps={{
                      name: 'Linha-credito',
                      id: 'linha-credito-select',
                    }}
                    MenuProps={{
                      anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                      },
                      transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left',
                      },
                      getContentAnchorEl: null,
                    }}
                    onChange={text =>
                      onChange({
                        ...propostaVersao,
                        meioPagamento: {
                          ...propostaVersao.meioPagamento,
                          linhaCredito: Number(text.target.value),
                        },
                      })
                    }
                  >
                    {propostaLinhaCredito
                      .filter(item => {
                        if (
                          propostaVersao.meioPagamento.formatoBanco === 'FCO' ||
                          propostaVersao.meioPagamento.formatoBanco === 'CDC'
                        ) {
                          return (
                            item.name ===
                            propostaVersao.meioPagamento.formatoBanco
                          );
                        }
                        return true;
                      })
                      .map(item => (
                        <MenuItem key={item.value} value={item.value}>
                          {item.name}
                        </MenuItem>
                      ))}
                  </Select>
                  <FormHelperText
                    hidden={propostaVersao.meioPagamento.linhaCredito !== 0}
                  >
                    {propostaVersao.meioPagamento.linhaCredito === 0
                      ? 'Obrigatório.'
                      : ''}
                  </FormHelperText>
                </FormControl>
              </Col>
            </>
          )}
        </Row>
      </CardBody>
    </Card>
  );
}
